export default __webpack_public_path__ + "static/media/online-payment 1.8467a531.svg";